export interface OpenAccountingPeriodConfigJson {
  delete_a_nouveau: boolean;
  delete_overturn: boolean;
  delete_cut_off: boolean;
}

export class OpenAccountingPeriodConfig {
  constructor(
    public deleteANouveau: boolean,
    public deleteOverturn: boolean,
    public deleteCutOff: boolean
  ) {}

  static toJson(data: OpenAccountingPeriodConfig): OpenAccountingPeriodConfigJson {
    return {
      delete_a_nouveau: data.deleteANouveau,
      delete_overturn: data.deleteOverturn,
      delete_cut_off: data.deleteCutOff
    };
  }
}
